import '../../components/tabs-talentech/tabsTalentech';
import '../../components/badge-talentech/badgeTalentech';
import '../../components/input-talentech/inputTalentech';
import '../../components/filters-talentech/filtersTalentech';
import '../../components/talmundo-chatbot/talmundoChatbot.dist.js';

// Talentech components
const talentechComponents = require.context('../../components', true, /dist.js$/);
export const ignoredElements = talentechComponents.keys().map((e) => e.split('/')[1]);
// Also ignore the chatbot custom element from `talmundo/talmundo-chatbot`
export const additionalIgnored = ['talmundo-chatbot'];
